import { Moment } from 'moment';

export interface Discount {
  id: number;
  from_date: string;
  end_date: string;
  name: string;
  percentage: number;
}

export interface DiscountModel {
  docs: Discount[];
  totalDocs: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

export interface payLoadAddDiscount {
  name: string;
  percentage: number;
  from_date: Moment;
  end_date: Moment;
}



export const discountBuilder = {
  toBackEnd: (discount): payLoadAddDiscount => {
    return {
      ...discount,
      from_date: discount.from_date.format('YYYY-MM-DD HH:mm') + ':00',
      end_date: discount.end_date.format('YYYY-MM-DD HH:mm') + ':00'
    };
  }
};
